import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import OsScroll from '../../ui/OsScroll';
import { logLines } from './runLogBuffer';

/**
 * The last lines a run printed (ANSI stripped, see runLogBuffer). Follows
 * the bottom while the user has not scrolled up.
 */
export default function RunLogView({ log }) {
  const { t } = useTranslation();
  const scrollRef = useRef(null);
  const follow = useRef(true);
  const lines = log ? logLines(log) : [];

  useEffect(() => {
    const viewport = scrollRef.current?.osInstance?.()?.elements().viewport;
    if (!viewport) return undefined;
    const onScroll = () => {
      follow.current = viewport.scrollHeight - viewport.scrollTop - viewport.clientHeight < 24;
    };
    viewport.addEventListener('scroll', onScroll);
    return () => viewport.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const viewport = scrollRef.current?.osInstance?.()?.elements().viewport;
    if (viewport && follow.current) viewport.scrollTop = viewport.scrollHeight;
  }, [lines.length, log?.partial]);

  return (
    <OsScroll ref={scrollRef} className="pj-run-log" data-testid="run-log">
      {lines.length === 0 ? (
        <div className="pj-run-log-empty">{t('projects.run.logEmpty')}</div>
      ) : (
        <pre className="pj-run-log-text">{lines.join('\n')}</pre>
      )}
    </OsScroll>
  );
}
